var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"radius-comp-wrapper",class:{
    '-border': _vm.border,
    '-default-background': _vm.defaultColoredBackground,
  },style:(_vm.wrapperStyle)},[_c('div',{staticClass:"content-holder"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }